import script from "./TempJoker.vue?vue&type=script&setup=true&lang=js"
export * from "./TempJoker.vue?vue&type=script&setup=true&lang=js"

import "./TempJoker.vue?vue&type=style&index=0&id=da79db08&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da79db08"]])

export default __exports__